import * as requestFromServer from './bankKurbanCrud';
import {bankKurbanSlice, callTypes} from './bankKurbanSlice';
import {toast} from "react-toastify";
import {toastOption} from "../../../../../_metronic/_helpers";
import {actions as auth} from "../../../Auth";

const {actions} = bankKurbanSlice;

export const fetchBankKurban = (queryParams) => dispatch => {
    dispatch(actions.startCall({callType: callTypes.list}));
    return requestFromServer
        .findBankKurban(queryParams)
        .then(response => {
            const {data: {total_items, items}} = response.data;
            dispatch(actions.bankKurbansFetched({total_items, items}));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({error, callType: callTypes.list}));
        });
};

export const uploadfile = (formData) => dispatch => {

    dispatch(actions.startCall({callType: callTypes.list}));
    return requestFromServer
        .uploadFile(formData)
        .then(response => {
            return response.data;
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({error, callType: callTypes.list}));
        });
};

export const getDataTag = (id, type) => dispatch => {

    return requestFromServer
        .getDataTagById(id, type)
        .then(response => {
            const {data} = response.data;
            return data;
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({error, callTypes: callTypes.list}));
        });
};

export const processDonation = (payload) => dispatch => {

    return requestFromServer
        .updateDonatur(payload)
        .then(response => {
            return response.data;
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({error, callTypes: callTypes.list}));
        });
};

export const processDonationKurban = (payload) => dispatch => {

    return requestFromServer
        .updateKurban(payload)
        .then(response => {
            return response.data;
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({error, callTypes: callTypes.list}));
        });
};
